import { provideHttpClient } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';

import type {
  BlobStorageAccess,
  LoginDto,
  UserToken,
} from '@plugins/shared/types/auth';

import { BLOB_CDN_ENDPOINT, HIDE_TOKENS, SERVERLESS } from './auth.const';
import { AuthGuard } from './auth.guard';
import {
  AuthInterceptor,
  HttpMockRequestInterceptor,
  httpMockRequestInterceptorFn,
  authInterceptorFn,
} from './auth.interceptor';
import { AuthService } from './auth.service';
import { BlobStoragePipe } from './blob.pipe';
import { BlobService } from './blob.service';

export interface AuthConfig {
  hideTokens?: boolean;
  blobCDNEndpoint?: string;
  serverless?: boolean;
}

const defaultConfig: AuthConfig = {
  hideTokens: true,
  blobCDNEndpoint: undefined,
  serverless: false,
};

@NgModule({})
export class AuthModule {
  static forRoot(config: AuthConfig = {}): ModuleWithProviders<AuthModule> {
    const _config = { ...defaultConfig, ...config };
    return {
      ngModule: AuthModule,
      providers: [
        provideHttpClient(),
        AuthService,
        BlobService,
        AuthInterceptor,
        AuthGuard,
        BlobStoragePipe,
        { provide: HIDE_TOKENS, useValue: _config.hideTokens },
        { provide: BLOB_CDN_ENDPOINT, useValue: _config.blobCDNEndpoint },
        { provide: SERVERLESS, useValue: _config.serverless },
      ],
    };
  }
}

export {
  AuthGuard,
  AuthInterceptor,
  AuthService,
  BLOB_CDN_ENDPOINT,
  BlobService,
  BlobStorageAccess,
  BlobStoragePipe,
  HttpMockRequestInterceptor,
  httpMockRequestInterceptorFn,
  LoginDto,
  UserToken,
  authInterceptorFn,
};
